
export default {
    name: 'PopUpLoading',

    computed: {
        open() {
            return this.$store.state.loading?.popUpLoading || false;
        },
    },

    watch: {
        open() {
            if (this.open) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style = '';
            }
        },
    },
};
